import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/farms')({
  component: FarmsDashboardComponent,
})

function FarmsDashboardComponent() {
  return <div>Hello "/_authenticated/farms"!</div>
}
